module.exports = __webpack_public_path__ + "static/media/bg-login.bf82141e.jpg";